import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (Id) {
  const { isRequestSuccessed, exec, rst } = useRequest({
    url: '',
    name: 'MACHINE_MODEL_DELETE',
    method: 'DELETE',
  });
  useEffect(() => {
    if (Id) {
      exec(`/api/machine/model/${Id}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id]);
  return [isRequestSuccessed, rst];
});
